/**
 * Pixsell API Spec
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.13.0-rev2
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Consent {
  id: number;
  title?: string;
  text?: string;
  is_required?: boolean;
  checkbox_title?: string;
  title_en?: string;
  text_en?: string;
  checkbox_title_en?: string;
}
